export default {
  homePage: "/",
  phonebookPage: "/phonebook",
  userRoom: "/account",
};
